import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useDialog } from "app/providers/dialog";
import _ from "lodash";
import { MouseEvent } from "react";
import Proposal from "work/entities/proposal/proposal";
import FeeScheduleCategories from "work/values/fee-schedule-category/view/fee-schedule-categories";
import { Masked } from "../../../entities/work-agreement/work-agreement";

const FeeLink = styled(
  Link,
  { shouldForwardProp: prop => prop !== 'revised' }
)<{ revised?: boolean }>(
  ({ theme, revised }) => ({
    alignItems: 'center',
    color: theme.palette.text.primary,
    cursor: 'pointer',
    display: 'flex',
    overflow: 'hidden',
    textDecoration: revised ? 'underline dotted red' : 'underline',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }));

type FeeScheduleLinkProps = {
  proposal: Proposal;
};

export default function FeeScheduleLink(props: Readonly<FeeScheduleLinkProps>) {
  const { openDialog } = useDialog();

  function handleClick(event: MouseEvent) {
    if (Masked.isMasked(props.proposal.feeSchedule)) {
      throw new Error("Cannot view masked fee schedule");
    }
    event.stopPropagation();
    const viewFeeScheduleComponent = (
      <FeeScheduleCategories
        hideActionsColumn={true}
        hideCommentButton={true}
        categories={props.proposal.feeSchedule}
        disableEditing={true}
        disableCategorySelection={true}
        commentsToolTip={""}
      />
    );

    openDialog({
      component: viewFeeScheduleComponent,
      title: 'Fee Schedule',
      MuiProps: {
        maxWidth: 'lg'
      }
    });
  }

  if (!props.proposal.feeSchedule) return null;
  if (Masked.isMasked(props.proposal.feeSchedule)) {
    return <span>(masked)</span>;
  }
  return (
    <FeeLink
      revised={
        !!(props.proposal?.supersedes &&
          !_.isEqual(
            props.proposal?.feeSchedule,
            props.proposal?.supersedes?.feeSchedule
          ))
      }
      onClick={handleClick}>
      View
    </FeeLink>
  );
}
